var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1586 28C16.7584 28 16.3783 27.8326 16.0981 27.5396L10.4352 21.617C9.85493 21.0101 9.85493 20.0056 10.4352 19.3987C11.0155 18.7918 11.976 18.7918 12.5563 19.3987L17.1586 24.2121L27.4437 13.4552C28.024 12.8483 28.9845 12.8483 29.5648 13.4552C30.1451 14.0621 30.1451 15.0666 29.5648 15.6735L18.2192 27.5396C17.939 27.8326 17.5588 28 17.1586 28Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxWhite);
export default __webpack_public_path__ + "static/media/checkbox-white.89bd5dff5f205e0e4feadd96d2317f5a.svg";
export { ForwardRef as ReactComponent };